import { HTTPError } from '@this/src/util';

const USER_SIGN_IN_PATH = '/users/sign_in';
const USER_AUTH_PASSWORD_PATH = '/users/auth/password';

export type OneTimePasswordRestartReason = 'CodeLocked' | 'CodeExpired' | 'LoginRequired';
export type SignInError = 'AccountLocked' | 'MailDeliveryFailed' | 'SessionExpired';
export type OneTimePasswordSignInResponse =
  | 'OneTimePasswordRequired'
  | 'MailDeliveryFailed'
  | 'SessionExpired'
  | OneTimePasswordRestartReason;

export const ONE_TIME_PASSWORD_MESSAGES: Record<string, string> = {
  MailDeliveryFailed: 'メールを送信できませんでした。時間をおいてもう一度お試しください。',
  SessionExpired:
    '別のタブで再ログインされたか、別のユーザーでログインされたため、このページのセッションが無効になりました。ページを再読み込みしてからお試しください。',
  InvalidCode: '認証コードが違います。',
  CodeLocked: '認証コードを5回間違えたため、無効になりました。もう一度ログインしてください。',
  CodeExpired: '有効期限が切れました。もう一度ログインしてください。',
  LoginRequired: '有効期限が切れました。もう一度ログインしてください。',
  ResendTooSoon: 'しばらく待ってから再送してください。'
};

const RESTART_REASONS: string[] = ['CodeLocked', 'CodeExpired', 'LoginRequired'];
const SIGN_IN_ERRORS: string[] = ['AccountLocked', 'MailDeliveryFailed', 'SessionExpired'];

export const isUserSignInPath = (pathname: string): boolean => pathname === USER_SIGN_IN_PATH;

export const signInRequestPath = (pathname: string): string =>
  isUserSignInPath(pathname) ? USER_AUTH_PASSWORD_PATH : pathname;

export const isOneTimePasswordRestartReason = (error: string | undefined): error is OneTimePasswordRestartReason =>
  error !== undefined && RESTART_REASONS.includes(error);

export const responseErrorCode = (e: unknown): string | undefined => {
  if (!(e instanceof HTTPError)) return undefined;

  const errors = e.response?.data?.errors;
  return Array.isArray(errors) && typeof errors[0] === 'string' ? errors[0] : undefined;
};

const isSignInError = (error: string | undefined): error is SignInError =>
  error !== undefined && SIGN_IN_ERRORS.includes(error);

export const signInErrorResponse = (e: unknown): SignInError | 'LoginFailed' => {
  const error = responseErrorCode(e);
  return isSignInError(error) ? error : 'LoginFailed';
};

export const csrfToken = (): string =>
  document.querySelector("meta[name='csrf-token']")?.getAttribute('content') ?? '';
